import React from 'react';
import properties from '../../../modules/ajio-util/properties';
import { generateEvent } from '../../../utils/dataGrinch';
// import utils from './../../../routes/views/utils'
// import { sanitize } from 'src/components/desktop/header/SearchBar';
import { sanitize } from '../../desktop/header/SearchBar';

class SocialSharing extends React.Component {
  constructor(props) {
    super(props);
  }
  

  render() {
    const { newinSocialShare = '', cpPageSocialShare = '', category = '' } = this.props;

    var url = window.location.href
    // let websiteURL = `${properties.getProperty("siteUrl")}${url}`;
    var websiteURL = `${url}`;

    if (cpPageSocialShare == true) {
      var productsAdditionalInfo = this.props.productsAdditionalInfo;
      var socialPageTitle = productsAdditionalInfo.title;
      var socialPrimaryImageUrl = productsAdditionalInfo.imageURL;
    } else if (newinSocialShare == true && category == 'women') {
      var socialPageTitle = "Shop for Women's Latest Capsule Collection at AJIO | AJIO";
      var socialPrimaryImageUrl = '';
    } else if (newinSocialShare == true && category == 'men') {
      var socialPageTitle = 'Shop Men’s Western Wear & Footwear Online | AJIO';
      var socialPrimaryImageUrl = '';
    } else if (newinSocialShare == true && category == 'kids') {
      var socialPageTitle = 'Kids Latest Capsule Collections | AJIO';
      var socialPrimaryImageUrl = '';
    }

    return (
      <div className="share-icons">
        <span className="icon-text">SHARE</span>
        <div className="quickview-social-sharing">
          <a
            className="qv-fb"
            href={`https://www.facebook.com/sharer.php?u=${websiteURL}&amp;t=${socialPageTitle}`}
            onClick={() => {
              generateEvent({
                Event: 'Share',
                value: {
                  Medium: 'Facebook',
                  CapsuleId: socialPageTitle,
                  PageUrl: websiteURL
                }
              });
            }}
            target="_blank"
            title="Facebook"
          >
            <div className="qv-fb-icon qv-social-sharing">
              <div className="social-tooltip">Share on facebook</div>
            </div>
          </a>

          <a
            className="qv-twitter"
            href={`https://twitter.com/intent/tweet?url=${websiteURL}`}
            target="_blank"
            title="Twitter"
            onClick={() => {
              generateEvent({
                Event: 'Share',
                value: {
                  Medium: 'Twitter',
                  CapsuleId: socialPageTitle,
                  PageUrl: websiteURL
                }
              });
            }}
          >
            <div className="qv-twitter-icon qv-social-sharing">
              <div className="social-tooltip">Tweet!</div>
            </div>
          </a>

          <a
            className="qv-pinterest"
            href={`http://pinterest.com/pin/create/button/?url=${websiteURL}&amp;description=${socialPageTitle}&amp;media=${websiteURL}${socialPrimaryImageUrl}`}
            target="_blank"
            title="Pinterest"
            onClick={() => {
              generateEvent({
                Event: 'Share',
                value: {
                  Medium: 'Pininterest',
                  CapsuleId: socialPageTitle,
                  PageUrl: websiteURL
                }
              });
            }}
          >
            <div className="qv-pinterest-icon qv-social-sharing">
              <div className="social-tooltip">Pin It!</div>
            </div>
          </a>

          <a
            className="qv-gplus"
            href={`https://plus.google.com/share?url=${websiteURL}&amp;utm_content=${socialPageTitle}&amp;utm_campaign=&amp;utm_medium=share%2Bbutton`}
            target="_blank"
            title="Google+"
            onClick={() => {
              generateEvent({
                Event: 'Share',
                value: {
                  Medium: 'Google Plus',
                  CapsuleId: socialPageTitle,
                  PageUrl: websiteURL
                }
              });
            }}
          >
            <div className="qv-gplus-icon qv-social-sharing">
              <div className="social-tooltip">Share on Google+</div>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

export default SocialSharing;
